import TitrePage from "../components/charte/TitrePage";
import React from "react";
import { Box, Typography } from "@mui/material";
import Notifications from "./notifications";
import { AIDE_RESEAU } from "../aide/textesAide";

/* Couleurs de la charte (src/theme/tribeTheme.ts), mêmes clés qu'avant. */
const C = {
  bg: "var(--c-bg)",
  text: "#1F1E1B",
  textSub: "#57534A",
} as const;

/* Notifications push seulement : l'onglet In-app gérait des contenus que
   l'app ne lit plus (feature_master), il a été retiré. */
export default function Communications() {
  return (
    <Box sx={{ background: C.bg, minHeight: "100vh", color: C.text, p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <TitrePage domaine="reseau" aide={AIDE_RESEAU.communications}>Communications</TitrePage>
        <Typography sx={{ fontSize: "13px", color: C.textSub, mt: 0.5 }}>
          Écrire aux Spotters par notification sur leur téléphone et revoir les messages envoyés.
        </Typography>
      </Box>
      <Notifications noHeader />
    </Box>
  );
}
